// this file is automatically generated by git.revision.js script
export const versions = { revision: '6c15f4e08c' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '6c15f4e08c';
